
<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/digitalsecurity">Digital Security</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Overview
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Digital Security</h2>

  <p class="lead">
                  Developing a security approach that provides 360-degree
                  protection is key and Important. And implementing security
                  technology is not enough. Organizations must have risk
                  management programs that bring people, process and technology
                  together to guard against threats at every organizational
                  layer including mobile devices, the data center edge, the
                  internet edge, between devices and machines, and among
                  multiple cloud environments.
                </p>

                <p class="lead">
                  Our Cyber Risk Management provides clients with a workable
                  strategy for effective security policies and procedures, risk
                  assessment and management, regulatory compliance, incident
                  response, and education and awareness. However, we combine our
                  technologies to provide the IT leader and board of directors
                  with an ongoing view of their organization’s risk exposure and
                  remediation path.
                </p>

                <p class="lead">
                  We offer Services and solutions to help you enjoy and have a
                  unique experience with our security management:
                </p>
                <ul class="lead">

                  <li>
                    <h4>Network security</h4> Define, enforce and monitor your security
                    policy.
                  </li>
                  <li>
                    <h4>Endpoint protection</h4> Secure your firm by protecting your
                    users and their devices.
                  </li>
                  <li>
                    <h4>Access control</h4> Enforcing security through policy enables
                    prod uctivity while maintaining security.
                  </li>
                  <li>
                    <h4>Identity and authentication</h4> Ensure user identity and
                    enforce the security policy.
                  </li>
                  <li>
                    <h4>Monitoring and visibility</h4> Get informed of security
                    incidents and details needed for solutions to security
                    threats.
                  </li>
                  <li>
                    <h4>Security services</h4> policy creation and Development,
                    vulnerability assessment and deployment expertise.
                  </li>
                </ul>
            </div>

            <div class="col-lg-4">
              <SecuritySideNav></SecuritySideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import SecuritySideNav from "./SecuritySideNav";
export default {
  name: "cloud overview",
  components: {
    SecuritySideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>


